import { signal } from "@preact/signals-react"

export const applicationGroupsSignal = signal([])
export const applicationGroupsLoadedSignal = signal(false)
export const applicationGroupsErrorSignal = signal(null)